/* This example requires Tailwind CSS v2.0+ */

import React from "react"
import Counter from "./counter"

/* This example requires Tailwind CSS v2.0+ */
export default function Stats() {
  return (
    <div className="bg-gray-50 pt-12 sm:pt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Our Impact
          </h2>
          <p className="mt-3 text-xl text-indigo-200 sm:mt-4">
            The Learning Curriculum is developed for all communities with a specialised focus for use by teachers, parents and other community educators
          </p>
        </div>
        <div className="mt-10 text-center sm:max-w-3xl sm:mx-auto sm:grid sm:grid-cols-3 sm:gap-8">
          <div className="flex flex-col">
            <dt className="order-2 mt-2 text-lg leading-6 font-medium text-indigo-200">
              Educators Trained
            </dt>
            <div className="flex justify-center order-1 text-5xl font-extrabold text-white">
              <Counter endPoint="13" />
              <p className="text-3xl align-left pt-1">+</p>
            </div>
          </div>
          <div className="flex flex-col mt-10 sm:mt-0">
            <dt className="order-2 mt-2 text-lg leading-6 font-medium text-indigo-200">
              Schools Directly Supported
            </dt>
            <Counter endPoint="4" />
          </div>
          <div className="flex flex-col mt-10 sm:mt-0">
            <dt className="order-2 mt-2 text-lg leading-6 font-medium text-indigo-200">
              Students Positively Impacted
            </dt>
            <div className="flex justify-center order-1 text-5xl font-extrabold text-white">
              <Counter endPoint="7500" />
              <p className="text-3xl align-left pt-1">+</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
